<div class="bgf-page workspace-page transactions">
    <section class="workspace-shell">
        <div class="workspace-shell__header">
            <div class="workspace-title-block">
                <span class="workspace-title-block__icon">
                    <i class="fa-solid fa-arrow-right-arrow-left"></i>
                </span>
                <div class="workspace-title-block__copy">
                    <h1>Készlet tranzakciók</h1>
                    <p>Részletes mozgásnapló az inventory műveletekről, rendelésekről és kézi beavatkozásokról.</p>
                </div>
            </div>

            <div class="workspace-shell__actions">
                <span class="workspace-meta-pill">
                    <i class="fa-solid fa-list"></i>
                    {{ dataSource.data.length | number:'1.0-0' }} tranzakció
                </span>
            </div>
        </div>

        <form class="workspace-filters" [formGroup]="filterFormGroup">
            <div class="workspace-filter-pill workspace-filter-pill--range">
                <i class="fa-regular fa-calendar"></i>
                <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate formControlName="from" placeholder="-tól" (dateChange)="fetchTransactions()">
                    <input matEndDate formControlName="to" placeholder="-ig" (dateChange)="fetchTransactions()">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </div>

            <button class="button is-light workspace-button" type="button" (click)="fetchTransactions()">
                <span class="icon"><i class="fa-solid fa-rotate"></i></span>
                <span>Frissítés</span>
            </button>
        </form>

        <div class="workspace-surface">
            <div class="workspace-surface__head">
                <div class="workspace-surface__copy">
                    <h2>Mozgásnapló</h2>
                    <p>Időrendben követhető, melyik komponenshez, melyik rendeléshez és melyik felhasználóhoz tartozik a változás.</p>
                </div>
            </div>

            <div class="workspace-table-wrap" [ngClass]="{'bgf-loading bgf-loading--color': fetching}">
                <table class="workspace-table workspace-table--dense" mat-table matSort [dataSource]="dataSource">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let element"> {{element.id}}</td>
            </ng-container>
            <ng-container matColumnDef="timestamp">
              <th mat-header-cell *matHeaderCellDef>Időpont</th>
              <td mat-cell *matCellDef="let element">
                <div class="workspace-cell-stack">
                    <strong>{{element.timestamp | date:'yyyy-MM-dd'}}</strong>
                    <span>{{element.timestamp | date:'HH:mm:ss'}}</span>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="component_id">
              <th mat-header-cell *matHeaderCellDef>SKU</th>
              <td mat-cell *matCellDef="let element">
                <a [routerLink]="'/components/' + element.component?.id" target="_blank" class="component-sku workspace-link">
                    {{element.component?.sku}} <i class="fa-solid fa-square-up-right"></i>
                </a>
              </td>
            </ng-container>
            <ng-container matColumnDef="component_name">
              <th mat-header-cell *matHeaderCellDef>Komponens neve</th>
              <td mat-cell *matCellDef="let element"> {{element.component?.name}}</td>
            </ng-container>
            <ng-container matColumnDef="order_id">
              <th mat-header-cell *matHeaderCellDef>Rendelés azon.</th>
              <td mat-cell *matCellDef="let element"> {{element.order?.id || '-'}}</td>
            </ng-container>
            <ng-container matColumnDef="order_customer">
              <th mat-header-cell *matHeaderCellDef>Rendelő neve.</th>
              <td mat-cell *matCellDef="let element"> {{element.order?.customer || '-'}}</td>
            </ng-container>
            <ng-container matColumnDef="quantity">
              <th mat-header-cell *matHeaderCellDef>Mennyiség</th>
              <td mat-cell *matCellDef="let element">
                <span class="workspace-count-badge">{{element.quantity}}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="user">
              <th mat-header-cell *matHeaderCellDef>Felhasználó</th>
              <td mat-cell *matCellDef="let element"> {{element.user?.full_name || 'Rendszer'}}</td>
            </ng-container>
            <ng-container matColumnDef="comment">
              <th mat-header-cell *matHeaderCellDef>Megjegyzés</th>
              <td mat-cell *matCellDef="let element"> {{element.comment || '-'}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <div class="workspace-empty-state" *ngIf="!fetching && !dataSource.data.length">
                    <i class="fa-solid fa-arrow-right-arrow-left"></i>
                    <h3>Nincs tranzakció a kiválasztott tartományban</h3>
                    <p>Próbálj más dátumintervallumot választani.</p>
                </div>
            </div>

            <div class="workspace-pagination">
                <mat-paginator [pageSizeOptions]="[20, 50, 100]"
                  showFirstLastButtons
                  aria-label="Tranzakciók lapozás">
                </mat-paginator>
            </div>
        </div>

        <div class="workspace-surface workspace-surface--secondary">
            <div class="workspace-surface__head">
                <div class="workspace-surface__copy">
                    <h2>Készlet snapshotok</h2>
                    <p>Gyors mentések és visszanézhető készletpontok ugyanebben a vizuális környezetben.</p>
                </div>
            </div>
            <div class="transactions__snapshots">
                <app-stock-snapshots></app-stock-snapshots>
            </div>
        </div>
    </section>
</div>
